import React, { useCallback, useContext } from 'react';
import { ArrowBack, ChevronForward, HomeOutline } from 'react-ionicons';
import FileExplorerContext from '../../contexts/FileExplorerContext';
import './ExplorerBreadcrumbs.scss';

const ExplorerBreadcrumbs = ({ path }) => {
    const { onOpenFolder, fullPath } = useContext(FileExplorerContext);

    const onFolderClick = useCallback(
        (folder) => {
            onOpenFolder(folder.id);
        },
        [onOpenFolder]
    );

    const onRootClick = useCallback(() => {
        onOpenFolder('');
    }, [onOpenFolder]);

    const onBack = useCallback(() => {
        if (fullPath.length === 0) {
            return;
        }

        if (fullPath.length === 1) {
            onRootClick();
            return;
        }

        const previousFolder = fullPath[fullPath.length - 2];

        onOpenFolder(previousFolder.id);
    }, [onOpenFolder, fullPath, onRootClick]);

    return (
        <div
            className="d-flex align-items-center"
            style={{ maxWidth: '70%', overflow: 'auto' }}
        >
            <div
                className="home-icon cursor-pointer me-2"
                style={{ opacity: path.length === 0 ? 0.2 : 1 }}
                onClick={onBack}
            >
                <ArrowBack color="inherit" width={'24px'} height={'24px'} />
            </div>
            <div
                className="d-flex align-items-center cursor-pointer breadcrumb-test"
                onClick={onRootClick}
            >
                <div className="home-icon">
                    <HomeOutline
                        color="inherit"
                        width={'24px'}
                        height={'24px'}
                    />
                </div>
                <span className="ps-2" style={{ paddingTop: 2 }}>
                    Home
                </span>
            </div>
            {path.map((folder, index) => (
                <div
                    key={`${folder.id}-${index}`}
                    className="d-flex align-items-center breadcrumb-test"
                >
                    <ChevronForward
                        color="gray"
                        width={'20px'}
                        height={'20px'}
                    />
                    <p
                        onClick={() => onFolderClick(folder)}
                        className="mb-0 text-nowrap cursor-pointer"
                        style={{ paddingTop: 2, paddingLeft: 4 }}
                    >
                        {folder.name}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default ExplorerBreadcrumbs;
